import Image from 'next/image';
import React, { useEffect } from 'react';
import { usePayment } from '@/features/subscription/hooks/usePayment';
import { useAppDispatch } from '@/hooks/redux';
import { hideSide } from '@/store/slices/sideSlice';
import { useTranslations } from 'next-intl';

const PaymentFailed = () => {
  const t = useTranslations('sides.payment_result.failed');
  const { resetPaymentStatus } = usePayment();
  const dispatch = useAppDispatch();

  useEffect(() => {
    resetPaymentStatus();
    setTimeout(() => {
      dispatch(hideSide());
    }, 3000);
  }, []);

  return (
    <div className="w-full h-dvh flex flex-col items-center justify-center">
      <div className="flex px-5 justify-center items-start">
        <div className="flex flex-col items-center w-full">
          <h2 className="text-center text-dark text-[32px] md:text-[40px] font-semibold">
            {t('title')}
          </h2>
          <Image
            src={'/images/notfound/notfound.svg'}
            width={298}
            height={260}
            alt="payment failed"
            className="mt-[32px]"
          />
          <p className="text-gray-medium text-[17px] md:text-lg mt-[32px] text-center">
            {t('message')}
          </p>

          <p className="text-gray-medium text-[17px] md:text-lg mt-2 text-center">
            {t('retry_info')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;
